import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 13.5L4.6357 8.32083C4.54872 8.23516 4.5 8.11997 4.5 8C4.5 7.88003 4.54872 7.76484 4.6357 7.67917L10 2.5",
		stroke: "currentColor",
		strokeWidth: 1.5
	})
});
export default SvgChevronLeft;
